import faqItemStyles from "./faqItem.module.css";
import { IContactUsTheme } from "../../utils/categories";
import { Dispatch, SetStateAction } from "react";
import { IFaq } from "../../services/types/user.types";
import i18n from "../../i18n";

interface IFaqItemProps {
  faq: IFaq;
  toggle: object;
  toggleAnswer: (id: number) => void;
  index: number;
  setToggle: Dispatch<SetStateAction<{}>>;
}
function FaqItem({
  faq,
  toggle,
  toggleAnswer,
  index,
  setToggle,
}: IFaqItemProps) {
  return (
    <li dir={i18n.dir()}
      className={`${faqItemStyles.faq__li} ${
        toggle[index as keyof typeof setToggle]
          ? faqItemStyles.faq__li_long
          : ""
      }`}
      onClick={() => toggleAnswer(index)}
    >
      <article className={faqItemStyles.faq__question}>
        <h3 className={faqItemStyles.faq__questionTitle}>{faq.question}</h3>
        <p className={faqItemStyles.faq__answer}>{faq.answer}</p>
      </article>
    </li>
  );
}

export default FaqItem;
